/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * SVM API
 * SVM API documentation
 * OpenAPI spec version: 1.0
 */

export type BoundaryPartRequestGeometryType =
    (typeof BoundaryPartRequestGeometryType)[keyof typeof BoundaryPartRequestGeometryType];

export const BoundaryPartRequestGeometryType = {
    CIRCLE: 'CIRCLE',
    POLYGON: 'POLYGON'
} as const;
